// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './FishFinderBuilder.css';
import LandingPage from './components/LandingPage';
import Parent from './Parent';
import QuickScreenComparison from './components/QuickScreenComparison';
import Summary from './components/Summary';
import SharedLayout from './components/SharedLayout';
import FishFinderBuilder from './components/FishFinderBuilder';
import SelectionFlow from './components/SelectionFlow';
import AskQuestion from './components/AskQuestion';
import QuickBundles from './components/QuickBundles';
import SimpleAmpedOutdoors30AhLiFePO4With3ACharger from './components/SimpleAmpedOutdoors30AhLiFePO4With3ACharger';
import SimpleAmpedOutdoors30AhLiFePO4BatteryOnly from './components/SimpleAmpedOutdoors30AhLiFePO4BatteryOnly';
import SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth from './components/SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth';
import SimpleAmpedOutdoors8AhLiFePO4BatteryOnly from './components/SimpleAmpedOutdoors8AhLiFePO4BatteryOnly';
import SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger from './components/SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger';
import SimpleAmped15AhLifePO4 from './components/SimpleAmped15AhLifePO4';
import SimpleAmped15AhLifePO4WithCharger from './components/SimpleAmped15AhLifePO4WithCharger';
import SimpleAmped19AhNMCWithCharger from './components/SimpleAmped19AhNMCWithCharger';
import SimpleAmped20AhLifePO4 from './components/SimpleAmped20AhLifePO4';
import SimpleAmped20AhLifePO4WithCharger from './components/SimpleAmped20AhLifePO4WithCharger';
import SimpleAmped52AhNMCBluetoothWithCharger from './components/SimpleAmped52AhNMCBluetoothWithCharger';
import SimpleHDIShuttle from './components/SimpleHDIShuttle';
import SimpleHDIShuttleDIYKit from './components/SimpleHDIShuttleDIYKit';
import SimpleUltra2106svLVS34Bundle from './components/SimpleUltra2106svLVS34Bundle';
import SimpleUltra2126svLVS34Bundle from './components/SimpleUltra2126svLVS34Bundle';
import SummitFishingShuttle from './components/SummitFishingShuttle';
import BreakAwayPoleTrackAllTerrain from './components/BreakAwayPoleTrackAllTerrain';
import BreakawayPoleFlatAllTerrain from './components/BreakawayPoleFlatAllTerrain';
import BreakawayPoleFlatOriginal from './components/BreakawayPoleFlatOriginal';

import FixedPoleFlatAllTerrain from './components/FixedPoleFlatAllTerrain';
import FixedPoleFlatOriginal from './components/FixedPoleFlatOriginal';
import HdiCarbon1836Lvs34 from './components/HdiCarbon1836Lvs34';
import HdiCarbon2460Lvs34 from './components/HdiCarbon2460Lvs34';
import HdiCarbon3280Lvs34 from './components/HdiCarbon3280Lvs34';
import HdiCarbon1836Lvs32 from './components/HdiCarbon1836Lvs32';
import HdiCarbon2460Lvs32 from './components/HdiCarbon2460Lvs32';
import HdiCarbon3280Lvs32 from './components/HdiCarbon3280Lvs32';
import SimpleProductEntry from './components/PriceComparison/SimpleProductEntry';
import ProductComparisonPage from './components/PriceComparison/ProductComparisonPage';
import ProductPriceComparison from './components/PriceComparison/ProductPriceComparison';
import GearCatalogPage from './components/gear/GearCatalogPage';
import IceFishingPage from './components/gear/IceFishingPage';
import GearProductPage from './components/gear/GearProductPage';
import { ThemeProvider } from './context/ThemeContext';
import SimplePriceComparison from './components/PriceComparison/SimplePriceComparison';
import ContactPage from './components/ContactPage';
import LinkListPage from './components/LinkListPage';
import LinkListPageOrganized from './components/LinkListPageOrganized';
import RouteTracker from './components/RouteTracker';
import CompareScreensV2Landing from './components/compareScreensV2/CompareScreensV2Landing';
import CompareScreensV2Compare from './components/compareScreensV2/CompareScreensV2Compare';
import CompareScreensV2Choose from './components/compareScreensV2/CompareScreensV2Choose';
import FgtnIndexPage from './components/fgtn/FgtnIndexPage';
import FgtnEpisodePage from './components/fgtn/FgtnEpisodePage';
import FgtnQrPage from './components/fgtn/FgtnQrPage';
import FgtnAdminPage from './components/fgtn/FgtnAdminPage';
import SeasonalLaunchPage from './components/launches/SeasonalLaunchPage';
import SeasonalLaunchQrPage from './components/launches/SeasonalLaunchQrPage';
import ProductVsComparisonPage from './components/comparisons/ProductVsComparisonPage';
import UpgradeComparisonPage from './components/comparisons/UpgradeComparisonPage';
import {
  COMPARISON_KIND,
  COMPARISON_PAGES,
} from './components/comparisons/comparisonConfigs';
import CompareHubPage from './components/compare/CompareHubPage';
import EarlyAccessPage from './components/earlyAccess/EarlyAccessPage';
import CompatibilityPage from './components/compatibility/CompatibilityPage';
import CompatibilityLanding from './components/compatibility/CompatibilityLanding';
import { COMPATIBILITY_PAGES } from './components/compatibility/compatibilityPageConfigs';
import NotFoundPage from './components/notFound/NotFoundPage';
import IceShowCalendarPage from './components/events/IceShowCalendarPage';

export function AppRoutes() {
  return (
    <Routes>
          <Route path="/fgtn/:episodeNumber/qr" element={<FgtnQrPage />} />
          <Route path="/ice-fishing/:launchSlug/qr" element={<SeasonalLaunchQrPage />} />
          <Route element={<SharedLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/BuildMyFishFinder/*" element={<Parent />} />
            <Route path="/custom-builder" element={<FishFinderBuilder />} />
            <Route path="/quick-bundles" element={<QuickBundles />} />
            <Route path="/compare-screens" element={<QuickScreenComparison />} />
            <Route path="/compare-screens-v2" element={<CompareScreensV2Landing />} />
            <Route path="/compare-screens-v2/choose" element={<CompareScreensV2Choose />} />
            <Route path="/compare-screens-v2/compare" element={<CompareScreensV2Compare />} />
            <Route path="/compare" element={<CompareHubPage />} />
            {COMPARISON_PAGES.map((comparison) => (
              <Route
                key={comparison.id}
                path={comparison.path}
                element={
                  comparison.kind === COMPARISON_KIND.UPGRADE ? (
                    <UpgradeComparisonPage config={comparison} />
                  ) : (
                    <ProductVsComparisonPage config={comparison} />
                  )
                }
              />
            ))}
            <Route path="/compatibility">
              <Route index element={<CompatibilityLanding />} />
              {COMPATIBILITY_PAGES.map((page) => (
                <Route
                  key={page.id}
                  path={page.path.replace(/^\/compatibility\//, '')}
                  element={<CompatibilityPage config={page} />}
                />
              ))}
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="/price-comparison" element={<GearCatalogPage />} />
            <Route path="/search" element={<GearCatalogPage siteSearch />} />
            <Route path="/ice-fishing" element={<IceFishingPage />} />
            <Route path="/ice-fishing/shows" element={<IceShowCalendarPage />} />
            <Route path="/ice-fishing/new-gear-2026-27" element={<GearCatalogPage newGear />} />
            <Route path="/gear/:slug" element={<GearProductPage />} />
            <Route path="/summary" element={<Summary />} />
            <Route path="/select/:componentType" element={<SelectionFlow />} />
            <Route path="/ask-question" element={<AskQuestion />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/early-access" element={<EarlyAccessPage />} />
            <Route path="/fgtn/admin" element={<FgtnAdminPage />} />
            <Route path="/fgtn/:episodeNumber" element={<FgtnEpisodePage />} />
            <Route path="/fgtn" element={<FgtnIndexPage />} />
            <Route path="/ice-fishing/:launchSlug" element={<SeasonalLaunchPage />} />
            <Route path="/blackfriday2025deals" element={<LinkListPage />} />
            <Route path="/bftest" element={<LinkListPageOrganized />} />
            <Route path="/simple-products/Ultra2 106sv + LVS34 Bundle" element={<SimpleUltra2106svLVS34Bundle />} />
            <Route path="/simple-products/Ultra2 126sv + LVS34 Bundle" element={<SimpleUltra2126svLVS34Bundle />} />
            <Route path="/simple-products/amped-30ah-lifepo4-with-charger" element={<SimpleAmpedOutdoors30AhLiFePO4With3ACharger />} />
            <Route path="/simple-products/amped-30ah-lifepo4" element={<SimpleAmpedOutdoors30AhLiFePO4BatteryOnly />} />
            <Route path="/simple-products/amped-32ah-nmc-with-charger" element={<SimpleAmpedOutdoors32AhNMCWith5AChargerWithBluetooth />} />
            <Route path="/simple-products/amped-8ah-lifepo4" element={<SimpleAmpedOutdoors8AhLiFePO4BatteryOnly />} />
            <Route path="/simple-products/amped-8ah-lifepo4-with-charger" element={<SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger />} />
            <Route path="/simple-products/amped-15ah-lifepo4" element={<SimpleAmped15AhLifePO4 />} />
            <Route path="/simple-products/amped-15ah-lifepo4-with-charger" element={<SimpleAmped15AhLifePO4WithCharger />} />
            <Route path="/simple-products/amped-19ah-nmc-with-charger" element={<SimpleAmped19AhNMCWithCharger />} />
            <Route path="/simple-products/amped-20ah-lifepo4" element={<SimpleAmped20AhLifePO4 />} />
            <Route path="/simple-products/amped-20ah-lifepo4-with-charger" element={<SimpleAmped20AhLifePO4WithCharger />} />
            <Route path="/simple-products/amped-52ah-nmc-bluetooth-with-charger" element={<SimpleAmped52AhNMCBluetoothWithCharger />} />
                      <Route path="/simple-products/breakaway-pole-track-all-terrain" element={<BreakAwayPoleTrackAllTerrain />} />
          <Route path="/simple-products/breakaway-pole-flat-all-terrain" element={<BreakawayPoleFlatAllTerrain />} />
          <Route path="/simple-products/breakaway-pole-flat-original" element={<BreakawayPoleFlatOriginal />} />

          <Route path="/simple-products/fixed-pole-flat-all-terrain" element={<FixedPoleFlatAllTerrain />} />
          <Route path="/simple-products/fixed-pole-flat-original" element={<FixedPoleFlatOriginal />} />
          <Route path="/simple-products/hdi-carbon-18-36-lvs34" element={<HdiCarbon1836Lvs34 />} />
          <Route path="/simple-products/hdi-carbon-18-36-lvs32" element={<HdiCarbon1836Lvs32 />} />
          <Route path="/simple-products/hdi-carbon-24-60-lvs34" element={<HdiCarbon2460Lvs34 />} />
          <Route path="/simple-products/hdi-carbon-24-60-lvs32" element={<HdiCarbon2460Lvs32 />} />
          <Route path="/simple-products/hdi-carbon-32-80-lvs34" element={<HdiCarbon3280Lvs34 />} />
          <Route path="/simple-products/hdi-carbon-32-80-lvs32" element={<HdiCarbon3280Lvs32 />} />
                    <Route path="/simple-products/hdi-shuttle" element={<SimpleHDIShuttle />} />
        <Route path="/simple-products/hdi-shuttle-diy-kit" element={<SimpleHDIShuttleDIYKit />} />
        <Route path="/simple-products/summit-fishing-shuttle" element={<SummitFishingShuttle />} />
            <Route path="/simple-products/db/:slug" element={<ProductComparisonPage />} />
            <Route path="/simple-products/:productId" element={<SimpleProductEntry />} />
            <Route path="/compare/:productIds" element={<SimplePriceComparison />} />
            <Route path="/products/:productId" element={<ProductPriceComparison />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <RouteTracker />
        <AppRoutes />
      </Router>
    </ThemeProvider>
  );
}

export default App;
